import { render, staticRenderFns } from "./Presentations.vue?vue&type=template&id=69265c36&scoped=true&"
import script from "./Presentations.vue?vue&type=script&lang=js&"
export * from "./Presentations.vue?vue&type=script&lang=js&"
import style0 from "./Presentations.vue?vue&type=style&index=0&id=69265c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69265c36",
  null
  
)

export default component.exports